/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BuchungscodeDto } from '../models/buchungscode-dto';
import { getAllBuchungscodes$Json } from '../fn/buchungscode/get-all-buchungscodes-json';
import { GetAllBuchungscodes$Json$Params } from '../fn/buchungscode/get-all-buchungscodes-json';
import { getAllBuchungscodes$Plain } from '../fn/buchungscode/get-all-buchungscodes-plain';
import { GetAllBuchungscodes$Plain$Params } from '../fn/buchungscode/get-all-buchungscodes-plain';

@Injectable({ providedIn: 'root' })
export class BuchungscodeApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllBuchungscodes()` */
  static readonly GetAllBuchungscodesPath = '/v1/buchungscodes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllBuchungscodes$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllBuchungscodes$Plain$Response(params?: GetAllBuchungscodes$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BuchungscodeDto>>> {
    return getAllBuchungscodes$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllBuchungscodes$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllBuchungscodes$Plain(params?: GetAllBuchungscodes$Plain$Params, context?: HttpContext): Observable<Array<BuchungscodeDto>> {
    return this.getAllBuchungscodes$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BuchungscodeDto>>): Array<BuchungscodeDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllBuchungscodes$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllBuchungscodes$Json$Response(params?: GetAllBuchungscodes$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BuchungscodeDto>>> {
    return getAllBuchungscodes$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllBuchungscodes$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllBuchungscodes$Json(params?: GetAllBuchungscodes$Json$Params, context?: HttpContext): Observable<Array<BuchungscodeDto>> {
    return this.getAllBuchungscodes$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BuchungscodeDto>>): Array<BuchungscodeDto> => r.body)
    );
  }

}
